module.exports = __webpack_public_path__ + "img/speedwork-logo.5ed41fc5.png";